import React from 'react';
import Navbar from '../components/brand/Navbar';
import Footer from '../components/brand/Footer';

const BookingPage = () => {
  return (
    <div className="min-h-screen bg-[#00001E] flex flex-col">
      <Navbar hideBookNow={true} />
      {/* pt-20 offsets the fixed navbar (h-20 = 80px) */}
      <main className="flex-1 pt-20">
        <iframe
          src="https://widget.zenbooker.com/book/1780394627155x692472259075121300?embed=true&fullpage=true"
          title="Book Online | Nura Health"
          allow="payment"
          style={{ width: '100%', minHeight: 'calc(100vh - 80px)', border: 0, display: 'block' }}
        />
      </main>
      <Footer />
    </div>
  );
};

export default BookingPage;
